export default __webpack_public_path__ + "static/media/img9.b259db29.png";